/**
 * File: BarList.tsx
 * Path: apps/admin/src/shared/components/overview/BarList.tsx
 * Description: A short list of labelled bars, the biggest one full width:
 * the Overview's "Biggest costs" and the Today page's pipeline, quote and
 * client boxes. A row with a link opens its record.
 */

import React from "react";
import { Link } from "react-router-dom";

export interface BarLine {
  id: string;
  label: string;
  value: string;
  /** 0 to 100. */
  share: number;
  href?: string;
}

export const BarList: React.FC<{ items: readonly BarLine[]; label: string }> = ({ items, label }) => (
  <ul className="space-y-stack-md" aria-label={label}>
    {items.map((item) => {
      const name = item.href ? (
        <Link to={item.href} className="min-w-0 truncate font-bold text-foreground hover:text-primary">
          {item.label}
        </Link>
      ) : (
        <span className="min-w-0 truncate font-bold text-foreground">{item.label}</span>
      );
      return (
        <li key={item.id} className="space-y-stack-xs">
          <div className="flex items-baseline justify-between gap-stack-sm text-sm">
            {name}
            <span className="shrink-0 tabular-nums">{item.value}</span>
          </div>
          <div className="h-2 bg-secondary">
            <div className="h-full bg-primary" style={{ width: `${Math.max(0, Math.min(100, item.share))}%` }} />
          </div>
        </li>
      );
    })}
  </ul>
);
